<template>
  <div
    class="payment-term credit-line-payment"
    :class="selected ? 'active' : ''"
    @click="selectTerm"
  >
    <h3>
      {{
        t("MONTHS_PAYMENT_PLAN", {
          months: months,
          weeks: weeks,
        })
      }}
    </h3>
    <hr class="m-0" />
    <div class="payment-term-badge">
      <div class="row payment-sub-header">
        <div class="col text-left">
          <span>{{ t("CREDIT_LINE_PAYMENTS") }}</span>
        </div>
        <div class="col text-right">
          <span>{{ t("MINIMUM_WEEKLY_AMOUNT") }}</span>
        </div>
      </div>
      <hr class="m-0" />
      <div class="row payment-line" v-if="props.currentMinimumPaymentAmount">
        <div class="col text-left">
          <span>{{ t("CURRENT") }}</span>
        </div>
        <div class="col text-right">
          <span>
            {{ formatCurrencyFromMerchant(props.currentMinimumPaymentAmount) }}
          </span>
        </div>
      </div>
      <div class="row payment-line">
        <div class="col text-left">
          <span>{{ t("NEW_CELLPHONE_AMOUNT") }}</span>
        </div>
        <div class="col text-right">
          <span>
            +
            {{
              formatCurrencyFromMerchant(
                props.minimumPaymentAmountForSimulatedDebit
              )
            }}
          </span>
        </div>
      </div>
      <div class="row payment-line payment-new-total">
        <div class="col text-left">
          <span>
            {{ t("NEW_DUE_PAYMENT") }}
          </span>
        </div>
        <div class="col text-right">
          <span>
            {{ formatCurrencyFromMerchant(props.newMinimumPaymentAmount) }}
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col d-flex text-left">
          <button class="btn pj-green-btn select">
            {{ t("TOTAL_PHONE_COST") }}
            {{ formatCurrencyFromMerchant(totalPhonePrice) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import { formatCurrencyFromMerchant } from "@/apps/merchant3/shared-helpers/format-currency.helper";

const { t } = useI18n();
const emit = defineEmits(["onSelect"]);

const props = defineProps({
  months: { type: Number, required: true },
  weeks: { type: Number, required: true },
  currentMinimumPaymentAmount: { type: Number, default: 0, required: false },
  minimumPaymentAmountForSimulatedDebit: {
    type: Number,
    default: 0,
    required: true,
  },
  newMinimumPaymentAmount: { type: Number, default: 0, required: true },
  totalPhonePrice: { type: Number, default: 0, required: true },
  selected: {
    type: Boolean,
    default: false,
  },
});

const selectTerm = () => {
  emit("onSelect", props.months);
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/constants";

h3 {
  color: $pj-color-green;
  font-size: 24px;
  line-height: 36px;
  padding: 0.3rem 1rem;
}

.payment-term {
  border: 2px solid $pj-color-light-gray;
  border-radius: 5px;
  cursor: pointer;
  &.active {
    border: 2px solid $pj-color-green;
    background-color: $pj-color-green-hover;
    .pj-green-btn {
      color: $pj-color-old-lavender;
      background-color: $pj-color-light-silver;
      box-shadow: none;
      border: none;
    }
  }
}

.payment-term-badge {
  padding: 0 1rem 1rem 1rem;
  margin-bottom: 1rem;
}

.payment-sub-header {
  color: $pj-color-gray;
  margin: 0.3rem 0;
  line-height: 19.6px;
}

.payment-new-total {
  font-weight: 700;
  font-size: 20px;
  line-height: 19.6px;
}

.payment-line {
  color: $pj-color-black;
  font-size: 15px;
  line-height: 28px;
}
</style>
